import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 32px;
  width: 100%;

  &[data-loading] {
    padding: 8px 0;
  }
`;

export const Info = styled.div`
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const BrandIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const BrandPlaceholder = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #f4f4f6;
  flex-shrink: 0;
`;

export const Details = styled.div`
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
`;

export const CardLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #131313;
  white-space: nowrap;
`;

export const Expiration = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #838486;
  white-space: nowrap;
`;

export const PrimaryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 4px 8px;
  border-radius: 5px;
  background: #e6f3f7;
  color: #131313;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
`;

export const MenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #838486;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;

  &:hover:not(:disabled) {
    background: #f4f4f6;
  }

  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }
`;

export const Divider = styled.hr`
  margin: 0;
  border: none;
  border-top: 1px solid #e7e8ec;
  width: 100%;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
